export const STUDY_BUDDY_MAX_PRACTICE_QUESTIONS = 15;

export function getStudyBuddyPracticeCreditCost(questionCount) {
  const count = Number(questionCount);
  if (!Number.isInteger(count)) return 0;
  if (count >= 1 && count <= 3) return 10;
  if (count >= 4 && count <= 8) return 20;
  if (count >= 9 && count <= STUDY_BUDDY_MAX_PRACTICE_QUESTIONS) return 40;
  return 0;
}

export function getStudyBuddyRequiredCredits(value) {
  const returned = Number(value?.required_credits);
  return Number.isInteger(returned) && returned > 0
    ? returned
    : getStudyBuddyPracticeCreditCost(value?.question_count);
}
